import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { SignUpService } from 'core/services/sign-up.service';
import { UserTypes } from '../shared/types/user.model';
import { KorviuLoaderComponent } from '../shared/components/korviu-loader/korviu-loader.component';

@Component({
  selector: 'app-accept-invitation',
  templateUrl: './accept-invitation.component.html',
  styleUrl: './accept-invitation.component.scss',
  standalone: true,
  imports: [KorviuLoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AcceptInvitationComponent implements OnInit {
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _signUpService = inject(SignUpService);

  private readonly registrationTypesByUserTypes = new Map<string, 'us' | 'mexican'>([
    [UserTypes.MX, 'mexican'],
    [UserTypes.PA, 'us'],
    [UserTypes.PR, 'us'],
    [UserTypes.CO, 'us'],
    [UserTypes.RE, 'us'],
    [UserTypes.MU, 'us'],
    [UserTypes.SD, 'us']
  ]);

  public ngOnInit(): void {
    this._route.paramMap.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((params: ParamMap) => {
      const userTypeCodeParam = params.get('user_type');
      const invitationIdParam = params.get('invitation_id');
      const userType = this.registrationTypesByUserTypes.get(userTypeCodeParam) || 'us';
      this._router.navigate(['auth', 'sign-up', userType, params.get('code')]);
      this._signUpService.invitationId = +invitationIdParam;
      this._signUpService.userTypeCode = userTypeCodeParam as UserTypes;
    });
  }
}
